<div class="table">
  <table fixedcols="[0,1]">
    <tr>
      <th>{{'Name'|translate}}</th>
      <th> <button [disabled]="!canEditTrackers" class="btn_img btn_graygray btn_plusorange" (click)="openAdd()"></button></th>
    </tr>
    <tr *ngFor="let event of linkednotifications">
      <td>{{event.Name}}</td>
      <td>
        <button [disabled]="!canEditTrackers" (click)="openEdit(event)" class="btn_img btn_edit" title="{{'Edit'|translate}}"></button>
        <button [disabled]="!canEditTrackers" (click)="deleteEvent(event)" class="btn_img btn_remove" title="{{'Delete'|translate}}"></button>
      </td>
    </tr>
  </table>
</div>
<template #objectsListDialog>
</template>
<template #mgmtDialog>
</template>
